export default function truncate (text, stop = 80, clamp = '...') {
    return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
};